import { render, staticRenderFns } from "./RecipientSelector.vue?vue&type=template&id=16c85791&"
import script from "./RecipientSelector.vue?vue&type=script&lang=js&"
export * from "./RecipientSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports